interface Props {
  size?: number;
}

export default function OpenExternallyIcon(props: Props) {
  const { size = 9 } = props;

  return (
    <svg height={size} viewBox="0 0 9.119 9" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.619 4.105V.5H5.014m0 3.605L8.619.5m-.91 5.59v.608c0 .995-.807 1.802-1.802 1.802H2.302A1.802 1.802 0 0 1 .5 6.698V3.093c0-.995.807-1.802 1.802-1.802h.72"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}
